import Axios from 'axios';
const AxiosInstance = Axios.create({
  baseURL: !!process.env.REACT_APP_URL ? process.env.REACT_APP_URL : "https://rentay.net/api",
});

AxiosInstance.interceptors.request.use(
  (config) => {
    config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

AxiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export {AxiosInstance as axios}